

export const ENSEIGNANT_MES_COURS_INITIATE_AJOUTER_SECTION = 'ENSEIGNANT_MES_COURS_INITIATE_AJOUTER_SECTION';
export const ENSEIGNANT_MES_COURS_AJOUTER_SECTION_START = 'ENSEIGNANT_MES_COURS_AJOUTER_SECTION_START';
export const ENSEIGNANT_MES_COURS_AJOUTER_SECTION_SUCCESS = 'ENSEIGNANT_MES_COURS_AJOUTER_SECTION_SUCCESS';
export const ENSEIGNANT_MES_COURS_AJOUTER_SECTION_FAIL = 'ENSEIGNANT_MES_COURS_AJOUTER_SECTION_FAIL';
export const ENSEIGNANT_MES_COURS_AJOUTER_SECTION_RESET = 'ENSEIGNANT_MES_COURS_AJOUTER_SECTION_RESET';